import { INTEGRATION_PROVIDER_IDS } from '@brew/integration-contracts'

import { DATA_IN_INTEGRATION_DEFINITIONS } from './data_in'
import { DATA_OUT_INTEGRATION_DEFINITIONS } from './data_out'
import type {
  IntegrationDefinition,
  IntegrationMeta,
  IntegrationProvider,
} from './types'

const INTEGRATION_DEFINITIONS = {
  ...DATA_OUT_INTEGRATION_DEFINITIONS,
  ...DATA_IN_INTEGRATION_DEFINITIONS,
} satisfies Record<IntegrationProvider, IntegrationDefinition>

/**
 * Canonical catalog rendered by the authenticated and public integration
 * surfaces. Provider order comes from the canonical provider ID tuple.
 */
export const integrationData: Array<IntegrationMeta> =
  INTEGRATION_PROVIDER_IDS.map((provider) => ({
    id: provider,
    ...INTEGRATION_DEFINITIONS[provider],
  }))

const INTEGRATION_META_BY_PROVIDER = new Map(
  integrationData.map((integration) => [integration.id, integration])
)

export function isIntegrationAvailable(provider: IntegrationProvider): boolean {
  return (
    INTEGRATION_META_BY_PROVIDER.get(provider)?.availability === 'available'
  )
}
